import { render, staticRenderFns } from "./RecensionComponent.vue?vue&type=template&id=5522a342&"
import script from "./RecensionComponent.vue?vue&type=script&lang=ts&"
export * from "./RecensionComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports